import React, { useEffect, useState, useRef } from "react";
import { CannyProvider, CannyFeedback } from "react-canny";
import { SkeletonGrid, Skeleton } from "components/ui/skeleton/UISkeleton";

const APP_ID = process.env.REACT_APP_CANNY_APP_ID;
const FEATURE_REQUEST_BOARD_TOKEN = process.env.REACT_APP_CANNY_FEATURE_REQUEST_BOARD_TOKEN;
const BUG_REPORT_BOARD_TOKEN = process.env.REACT_APP_CANNY_BUG_REPORT_BOARD_TOKEN;

const CannyWidgetFR = ({ user, ssoToken, theme, boardType = 'feature' }) => {
  const [iframeLoaded, setIframeLoaded] = useState(false);
  const containerRef = useRef(null);
  
  // Select board token based on boardType
  const getBoardToken = () => {
    if (boardType === 'bug') {
      return BUG_REPORT_BOARD_TOKEN;
    }
    return FEATURE_REQUEST_BOARD_TOKEN;
  };
  
  const BOARD_TOKEN = getBoardToken();

  useEffect(() => {
    const observer = new MutationObserver(() => {
      const iframe = containerRef.current?.querySelector("iframe");
      if (iframe) {
        iframe.onload = () => {
          setIframeLoaded(true);
        };
        observer.disconnect();
      }
    });

    if (containerRef.current) {
      observer.observe(containerRef.current, {
        childList: true,
        subtree: true,
      });
    }

    return () => observer.disconnect();
  }, []);

  if (!user || !ssoToken) return null;

  return (
    <CannyProvider appId={APP_ID}>
      <div
        ref={containerRef}
        style={{ position: "relative", minHeight: "400px" }}
      >
        {!iframeLoaded && (
          <div
            style={{
              position: "absolute",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              zIndex: 10,
              padding: "16px",
              boxSizing: "border-box",
              backgroundColor: theme === "dark" ? "#23224F" : "#fff",
              overflowY: "hidden",
            }}
          >
            <SkeletonGrid spacing={2}>
              <Skeleton type="text" rows={2} height={20} col={12} radius={4} />
              <Skeleton type="text" rows={1} height={20} col={6} radius={4} />
              <Skeleton type="text" rows={1} height={20} col={6} radius={4} />
              <Skeleton type="image" height={180} col={12} radius={8} />
              <Skeleton type="image" height={180} col={12} radius={8} />
            </SkeletonGrid>
          </div>
        )}

        <CannyFeedback
          boardToken={BOARD_TOKEN}
          ssoToken={ssoToken}
          theme={theme}
          user={user}
        />
      </div>
    </CannyProvider>
  );
};

export default CannyWidgetFR;
